import '../scss/jquery.selectify.scss';

/*!
 * Selectify - A light-weight, mobile-ready and customizable select plugin for jQuery
 *
 * Copyright 2018, Mehdi Dehghani
 *
 * @author   Mehdi Dehghani (http://www.github.com/dehghani-mehdi)
 * @license  Licensed under MIT (https://github.com/dehghani-mehdi/selectify/blob/master/LICENSE)
 *
 */
; (function ($, window, document, undefined) {
    var pluginName = "selectify",
        classNames = {
            select: 'selectify__select',
            container: 'selectify__container',
            itemsContainer: 'selectify__items',
            selected: 'selectify__selected',
            active: 'selectify__active'
        },
        defaults = {
            init: null,
            position: {
                right: null,
                left: null,
                hGap: null,
                vGap: null
            },
            dir: 'ltr',
            onChange: null
        };

    function Plugin(el, options) {
        this.el = el;
        this.$el = $(el);
        this.$body = $('body');
        this.options = $.extend({}, defaults, options);
        //this.options = $.extend(true, {}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.items = [];

        this.init();
    }

    Plugin.prototype = {
        init: function () {
            this.$el.find('option').each((_, el) => {
                let $this = $(el);

                this.items.push({
                    value: $this.val(),
                    text: $this.text(),
                    icon: $this.data('icon')
                });
            });

            if (this.items.length === 0) return;

            this.$el.addClass(classNames.select);
            this.appendContainer();
            this.wireEvents();
        },
        appendContainer: function () {
            this.$container = $('<div />', { class: `${classNames.container} selectify__${this.options.dir}` }).insertAfter(this.$el);

            if (this.options.init) {
                let item = this.items.filter(x => x.value == this.options.init);

                if (item.length === 1) this.$container.text(item[0].text).data('value', item[0].value);
            }
        },
        appendItems: function () {
            let x = this.$body.find(`.${classNames.itemsContainer}`);

            if (x.length > 0) x.remove();

            this.$itemsContainer = $('<div />', { class: `${classNames.itemsContainer} selectify__${this.options.dir}` }).appendTo(this.$body);

            let $items = [],
                currentSelectedValue = this.$el.data('selected-value');

            for (let i = 0; i < this.items.length; i++) {
                let item = this.items[i],
                    $div = $('<div />', {
                        'data-value': item.value,
                        text: item.text
                    });

                if (item.icon && item.icon.length > 0) $div.prepend($('<img />', { src: item.icon }));

                $div.on('click', (e) => this.handleOptionClick(e, item.value, item.text));

                $items.push($div);
            }

            this.$itemsContainer.empty().append($items);

            for (let i = 0; i < $items.length; i++) {
                let $this = $items[i],
                    value = $this.data('value');

                if (currentSelectedValue && currentSelectedValue == value) {
                    $this.addClass(classNames.selected);
                    break;
                }

                if (this.options.init && this.options.init == value) {
                    $this.addClass(classNames.selected);
                    break;
                }
            }
        },
        wireEvents: function () {
            this.$container.on('click', (e) => {
                e.stopPropagation();

                this.appendItems();

                let $this = $(e.currentTarget),
                    w = e.currentTarget.offsetWidth,
                    offset = $this.offset(),
                    left = offset.left,
                    top = offset.top;

                this.$itemsContainer
                    .css({ top: top, 'min-width': w })
                    .toggleClass(classNames.active);

                if (this.options.dir === 'ltr') this.$itemsContainer.css('left', this.options.position.left || left);
                else {
                    let rect = this.$container[0].getBoundingClientRect();

                    this.$itemsContainer.css('right', this.options.position.right || this.$body.width() - left - rect.width);
                }

                if (this.options.position.hGap) this.$itemsContainer.css('margin-top', this.options.position.hGap);
                if (this.options.position.vGap) this.$itemsContainer.css(`margin-${this.options.dir === 'ltr' ? 'left' : 'right'}`, this.options.position.vGap);

                $this.toggleClass(classNames.active);
                if (!$this.hasClass(classNames.active)) $(`.${classNames.itemsContainer}`).removeClass(classNames.active);
            });

            $('body').on('click', () => {
                $(`.${classNames.itemsContainer}`).removeClass(classNames.active);
                this.$container.removeClass(classNames.active);
            });
        },
        handleOptionClick: function (e, value, text) {
            e.stopPropagation();

            this.changeSelectedItem($(e.currentTarget), value, text, 'click event');
        },
        changeSelectedItem: function ($item, value, text, source) {
            let currentSelectedValue = this.$el.data('selected-value'),
                itemText;

            if (currentSelectedValue && currentSelectedValue == value) return;

            this.$el.data('selected-value', value);

            itemText = typeof text === 'undefined' ? $item.text() : text;

            if (typeof this.$itemsContainer === 'undefined') this.$itemsContainer = $(`.${classNames.itemsContainer}`);

            this.$itemsContainer.removeClass(classNames.active);
            this.$container
                .text(itemText)
                .removeClass(classNames.active);

            this.$itemsContainer.find(classNames.selected).removeClass(classNames.selected);
            $item.addClass(classNames.selected);

            if (source === 'click event') {
                if (typeof this.options.onChange === 'function') this.options.onChange.call(this, value, itemText);

                this.$el.trigger('change', value);
            }
        },
        set: function (value) {
            let $item = this.$el.find(`option[value=${value}]`);

            this.changeSelectedItem($item, value, $item.text(), 'set method');
        },
        get: function () {
            return this.$el.data('selected-value');
        }
    };

    var methods = {
        set: function () {
            this.data("plugin_" + pluginName).set(arguments[0]);
        },
        get: function () {
            return this.data("plugin_" + pluginName).get();
        }
    };

    $.fn[pluginName] = function (options) {
        if (methods[options]) return methods[options].apply(this, Array.prototype.slice.call(arguments, 1));

        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
    };

})(jQuery, window, document);